// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/static/css/async/" + chunkId + "." + {"366": "b8543c19","912": "57f92e5a",}[chunkId] + ".css"
}